import React from "react";

export default function AccessDenied() {
  return (
    <div className="access-denied pt-5">
      <text className="access-denied-content">
        <b>Access Denied </b>
        <br />
        Please write to{" "}
        <a href="mailto:contact@indiainvestmentgrid.com">
          {" "}
          contact@indiainvestmentgrid.com{" "}
        </a>{" "}
        &<a href="mailto:pmg@investindia.org.in">
          {" "}
          pmg@investindia.org.in{" "}
        </a>{" "}
        for support
      </text>
    </div>
  );
}
